<template>
  <a-modal
    :title="title"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    @ok="ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="锁价日期" v-if="this.model['type'] !== 3">
              <a-date-picker
                style="width: 50%"
                v-decorator="['lock_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="锁价日期"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item label="锁价日期" v-else>
              <a-range-picker
                @change="time"
                format="YYYY-MM-DD"
                style="width: 100%"
                v-decorator="['lock_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
            <a-form-item label="锁价数量">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['lock_count', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="锁价价格">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['lock_price', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="是否转月">
              <a-switch v-decorator="['is_rollover', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否" @change="rolloverChange"/>
            </a-form-item>
            <a-form-item label="月差">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['monthly_spread', {initialValue: 0, rules: [{required: this.rollover, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    return {
      form: this.$form.createForm(this),
      dictionaries: this.$Dictionaries,
      rollover: false,
      param: {}
    }
  },
  computed: {
    title () {
      return () => {
        return this.model['type'] === 1 ? 'TAS' : 'Trigger'
      }
    }
  },
  methods: {
    time (dates, dateStrings) {
      this.param.start_date = dateStrings[0]
      this.param.end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    rolloverChange (value) {
      this.rollover = value
    },
    ok () {
      if (this.model['type'] !== 3) {
        this.$emit('ok')
      } else {
        this.$emit('ok', this.param)
      }
    }
  }
}
</script>
